import { createContext } from "react";
import { ISession } from "types";

const AuthUserContext = createContext(null as unknown as ISession);

export default AuthUserContext;
